export function timeSince(date: Date): string {
  const now = Date.now();
  const secondsPast = (now - date.getTime()) / 1000;

  if (secondsPast < 60) {
    const seconds = Math.floor(secondsPast);
    return `${seconds} second${seconds === 1 ? '' : 's'} ago`;
  } else if (secondsPast < 3600) {
    const minutes = Math.floor(secondsPast / 60);
    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  } else if (secondsPast < 86400) {
    const hours = Math.floor(secondsPast / 3600);
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  } else {
    const days = Math.floor(secondsPast / 86400);
    return `${days} day${days === 1 ? '' : 's'} ago`;
  }
}
